import Vue from 'vue';
import PluginEnvironment from './environment';
import { optionsTagManager, VueTagManager } from './gtm';

Vue.use(PluginEnvironment);
Vue.use(VueTagManager, optionsTagManager);
